import moment from 'moment'

export function standardFormatter(value: string): string {
  return value ? value : '-'
}
export function moneyFormatter(amount: string): string {
  return amount ? '$' + amount : '-'
}
export function dateFormatter(date: string): string {
  return date ? moment(date, 'YYYY/MM/DD').format('MM/DD/YYYY') : '/ - / - /'
}
export function percentageFormatter(percentage: string): string {
  return percentage ? percentage + '%' : '-'
}
export function ssnFormatter(ssn: string): string {
  if (ssn) {
    ssn = ssn.replace(/\D/g, '')
    ssn = ssn.replace(/^(\d{3})/, '$1-')
    ssn = ssn.replace(/-(\d{2})/, '-$1-')
    ssn = ssn.replace(/(\d)-(\d{4}).*/, '$1-$2')
    return ssn
  } else {
    return '-'
  }
}
export function phoneFormatter(phoneNum: string): string {
  if (phoneNum) {
    phoneNum = ('' + phoneNum).replace(/\D/g, '')
    let match = phoneNum.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      let intlNum = (match[1] ? '+1 ' : '')
      return [intlNum, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return phoneNum
  } else {
    return '-'
  }
}
export function phoneReformatter(phoneNum: string): string {
  if (phoneNum) {
    return phoneNum.replace(/\(|\)|\s|-/g, '')
  } else {
    return phoneNum
  }
}
